import {asREM} from '@raison/ui-kit';
import React, {useEffect} from 'react';
import spriteUrl from './country-flags.svg';

export interface CountryFlagProps {
    iso: string;
    size?: number;
}

export const CountryFlag = ({iso, ...props}: CountryFlagProps) => {
    const size = props.size ? asREM(props.size) : '100%';
    return (
        <div style={{minWidth: size, width: size, height: size}}>
            <img width='100%' height='100%' src={`${spriteUrl}#country-iso-${iso}`} />
        </div>
    );
};

let cached = false;
export function preloadCountriesSprite() {
    if (!cached) {
        const img = new Image();
        img.src = spriteUrl;
        img.addEventListener('error', () => {
            cached = false;
        });
        cached = true;
    }
}

export function usePreloadCountriesSprite() {
    useEffect(preloadCountriesSprite, []);
}
